import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { State } from '../../util/interactiveState.js';
import mix from '../../util/mix.js';
import { selectToken } from '../../util/tokenSelector.js';
import toRgbColor from '../../util/toRgbColor.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sliderInteractiveState = function sliderInteractiveState(theme, thumbBackgroundColor) {
  if (!theme || !thumbBackgroundColor) return null;

  // interactive focus indicator
  var textPrimaryInteractiveToken = selectToken(theme.text, 'product.primary');
  if (!textPrimaryInteractiveToken) return null;
  var textNeutral4Token = selectToken(theme.text, 'base.inverted');
  if (!textNeutral4Token) return null;
  var primaryColorToken = selectToken(theme.background, 'product.primary');
  if (!primaryColorToken) return null;
  var primaryColor = toRgbColor(primaryColorToken);
  var colorRgb = "".concat(primaryColor.red, ", ").concat(primaryColor.green, ", ").concat(primaryColor.blue);

  // TODO: ADSWEB-1096 &::after doesn't work with shadow elements, needs color mixing workaround
  var baseStyles = function baseStyles(thumbSelector) {
    return _defineProperty(_defineProperty({}, "&".concat(State.Hover).concat(thumbSelector), {
      backgroundColor: mix(thumbBackgroundColor, "rgba(".concat(colorRgb, ", 0.08)"))
    }), "&".concat(State.FocusedVisible).concat(thumbSelector, ", &").concat(State.Focused).concat(thumbSelector), {
      backgroundColor: mix(thumbBackgroundColor, "rgba(".concat(colorRgb, ", 0.12)")),
      // TODO: ADSWEB-729 Token for outline width
      boxShadow: "0 0 0 2px ".concat(textNeutral4Token, ", 0 0 0 4px ").concat(textPrimaryInteractiveToken)
    });
  };
  return _objectSpread(_objectSpread({}, baseStyles('::-webkit-slider-thumb')), baseStyles('::-moz-range-thumb'));
};

export { sliderInteractiveState as default };
//# sourceMappingURL=sliderInteractiveState.js.map
